module.exports = __webpack_public_path__ + "img/foot.be5030ca.webp";